export class IrisBase {                
    constructor() {        
    }
}
